/* Touché · Promoción con regalo: contador y vencimiento.
   El contador cuenta hasta la fecha real de fin cargada en Shopify
   (data-end, en milisegundos), así que recargar la página no lo reinicia.
   Cuando llega a 0 oculta el recuadro y las etiquetas, y deja de anotar
   el regalo en el carrito. */
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function expire(el) {
    if (el.tagName === 'INPUT') { el.remove(); } else { el.hidden = true; }
  }

  function sweep() {
    var now = Date.now();
    var items = document.querySelectorAll('[data-tpr-end]');
    for (var i = 0; i < items.length; i++) {
      var end = parseInt(items[i].getAttribute('data-tpr-end'), 10);
      if (end && end <= now) { expire(items[i]); }
    }
  }

  if (!customElements.get('touche-promo-timer')) {
    customElements.define('touche-promo-timer', class extends HTMLElement {
      connectedCallback() {
        this.end = parseInt(this.dataset.end, 10) || 0;
        this.h = this.querySelector('[data-h]');
        this.m = this.querySelector('[data-m]');
        this.s = this.querySelector('[data-s]');
        this.tick();
        clearInterval(this.timer);
        this.timer = setInterval(this.tick.bind(this), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        var ms = this.end - Date.now();
        var left = Math.max(0, Math.floor(ms / 1000));
        if (this.h) this.h.textContent = pad(Math.floor(left / 3600));
        if (this.m) this.m.textContent = pad(Math.floor((left % 3600) / 60));
        if (this.s) this.s.textContent = pad(left % 60);
        if (ms <= 0) { clearInterval(this.timer); sweep(); }
      }
    });
  }

  /* Anota "Regalo: …" en cualquier formulario de compra de un producto en
     promo (ficha, tarjetas y vista rápida), si el tema no lo hizo ya. */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (form.elements && form.elements['properties[Regalo]']) return;
    var scope = form.closest('.product-card, modal-dialog, .f-product-single__blocks, [id^="ProductInfo-"]');
    var mark = scope && scope.querySelector('[data-tpr-gift]:not([hidden])');
    if (!scope) {
      /* Barra fija de "Agregar al carrito" de la ficha: usa el recuadro de la página */
      mark = document.querySelector('.f-product-single__blocks .tpr[data-tpr-gift]:not([hidden])');
    }
    if (!mark) return;
    var gift = mark.getAttribute('data-tpr-gift');
    var end = parseInt(mark.getAttribute('data-tpr-end'), 10);
    if (!gift || !end || end <= Date.now()) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[Regalo]';
    input.value = gift;
    input.setAttribute('data-tpr-end', String(end));
    form.appendChild(input);
  }, true);

  sweep();
  setInterval(sweep, 30000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) sweep(); });
})();
